import { render, staticRenderFns } from "./ChatListView.vue?vue&type=template&id=6575d052&"
import script from "./ChatListView.vue?vue&type=script&lang=js&"
export * from "./ChatListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports